import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-challenge-v002',
  templateUrl: './challenge-v002.component.html',
  styleUrls: ['./challenge-v002.component.scss']
})
export class ChallengeV002Component implements OnInit {

  @Input() timer;

  constructor() { }

  ngOnInit(): void {
  }

}
